import {Component, OnInit} from '@angular/core';
import { Routing } from 'src/app/models/routing/routing';
import {FastDialNumber} from '../../../models/fast-dial-number';
import {RestApiService} from '../../../services/api';
import {AclPermission} from '../../../models/acl/acl-group';
import { ButtonDirective } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { PrimeTemplate } from 'primeng/api';
import { AclRequiredDirective } from '../../../directives/acl-required.directive';
import { RouterLink } from '@angular/router';
import {PopoverComponent} from '../../panels/popover/popover.component';

@Component({
    selector: 'app-fast-dial-numbers',
    templateUrl: './fast-dial-numbers.component.html',
    styleUrls: ['./fast-dial-numbers.component.scss'],
    imports: [
        ButtonDirective,
        TooltipModule,
        TableModule,
        PrimeTemplate,
        AclRequiredDirective,
        RouterLink,
        PopoverComponent
    ]
})
export class FastDialNumbersComponent implements OnInit {

    numbers: FastDialNumber[] = [];
    loading = false;
    loadingError = false;

    Routing = Routing;
    AclPermission = AclPermission;
    obj(item: FastDialNumber) {
        return item;
    }

    constructor(private api: RestApiService) {
    }

    ngOnInit(): void {
        this.loadFastDialNumbers();
    }

    async loadFastDialNumbers() {
        this.loading = true;
        try {
            this.numbers = (await this.api.fastDialNumbers.getAll()).data;
        } catch (e) {
            this.loadingError = true;
        } finally {
            this.loading = false;
        }
    }
}
